export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);

export const lerp = (start: number, end: number, progress: number): number =>
  start + (end - start) * progress;

export const easeOutCubic = (value: number): number => 1 - Math.pow(1 - value, 3);

export const easeInOutSine = (value: number): number =>
  -(Math.cos(Math.PI * value) - 1) / 2;
